<template>
	<div class="LFPopUp animated fadeIn " v-show="disp">
		<div class="bacView" @click="clickBac">
			<div class="coreView">
				<div class="imgView ">
					<!-- <div v-html="i.html" v-if="i.name==sampleName" v-for="(i,index) in imageAry"></div> -->
					<div v-html="productHtml"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	// import axios from 'axios'
	import request from '../common/request.js'
	
	export default {
		name: 'LFPopUp',
		props: {
			sampleName: {
				default: "",
			},
			productHtml: {
				type:String,
				default: ''
			}
		},
		data() {
			return {
				url: "",
				imageAry: [],
			}
		},
		mounted() {
			// this.listData();
		},
		methods: {
			clickBac(e) {
				// console.log(e.target.className);
				if(e.target.className == 'bacView'){
					this.$emit('clickBac');
				}

			},
			listData(){
				let that = this;
				let project_name = "web";
				let type = 'CPXXZS';
				let data = {
					"project_name": project_name,
					"type": type,
					}
				// console.log("haha");
				let requests = request.getQueryData(data ||{})
				// console.log("haha",requests);
				that.$axios.post('/api_app/v2/mall/configinfo',       // 还可以直接把参数拼接在url后边
					requests).then(function(data){
						// console.log("data",data);
						if(data.data.ResultCode == 200){
							for (let itme of data.data.data) {
								let poster = {
									name:itme.name,
									html:itme.html.html
								}
								that.imageAry.push(poster);
							}

						}
				    }).catch(function (err) {
				        // console.log('err', err);
				    });
			}
		},
		computed: {
			disp() {
				// return this.imageAry.length > 0;
				return this.productHtml !== ''
			}
		}
	}
</script>

<style>
	.LFPopUp {
		width: 100%;
		height: 100%;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		position: fixed;
		z-index: 9999;
		overflow: auto;
		animation-duration: 1s !important;
	}

	.bacView {
		width: 100%;
		/* height: 100%; */
		min-height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		display: flex;
		/* align-items: center; */
		position: relative;
	}

	.bacView .coreView {
		
		background-color: white;
		align-self: center;
		width: 100%;
		max-width: 1024px;
		/* height: 40.5rem; */
		position: relative;
		margin: 6.0rem auto;
		/* margin-top: 6.0rem; */
	}

	.bacView .coreView .imgView {
		width: 100%;
		margin: 0 a;
		font-size: 0;
		/* height: 100%; */
	}

	.bacView .coreView .imgView img {
		width: 100%;
		/* height: 50.75rem; */
	}
</style>
